import { IMapBounds } from '../../map.interface';
import { CarFilters } from '../../station.interface';

export module IClientSocket {

  export module Dto {

    export class HandshakeData {
      clientId: string;
    }

    export type MapBounds = IMapBounds;

    export interface CurrentBoundsData {
      mapBounds: IMapBounds;
      filters?: Partial<CarFilters>;
      userVisibilityGroups?: number[];
    }
  }

  export type ValueOf<T> = T[keyof T];

  export const ClientEvents = Object.freeze({
    Handshake: 'handshake',
    GetInstallationById: 'GetInstallationById',
    CurrentBounds: "current_bounds",
    GetClusterByIds: 'GetClusterByIds'
  });

  export type ClientEventsValues = ValueOf<typeof ClientEvents>;
  export type ClientEventsKeys = keyof typeof ClientEvents;


  export const ServerEvents = Object.freeze({
    SessionUpdates: "session_updates",
    InstallationsUpdates: "installations_updates",
    /**
     * "Qualcosa dentro questa installazione è cambiato": connettore, stazione, o qualunque cosa
     * si aggiunga in futuro. Recapitato SOLO a chi ha la scheda aperta (room `inst:{id}:detail`).
     *
     * Un evento solo, e non uno per tipo di entità, perché il destinatario reagisce sempre allo
     * stesso modo — si riallinea la scheda — e perché `installations_updates` (che va anche alla
     * mappa) NON copre questi casi: l'aggregato dell'installazione può restare identico mentre un
     * connettore o una stazione cambiano. Payload `[{ id }]`, come gli altri update.
     * Additivo: i client che non lo conoscono lo ignorano.
     */
    InstallationDetailUpdates: "installation_detail_updates",
    RfidUpdates: "rfid_updates",
    GeneralNotification: "general_notification",
  });

  export type ServerEventsValues = ValueOf<typeof ServerEvents>;
  export type ServerEventsKeys = keyof typeof ServerEvents;
}
